<ng-template [ngIf]="isNotManualFlow">
    <input id="text-input-field" #inputShares [value]="params.value ?? ''" (keypress)="validateInput($event)" (focus)="onFocus($event)"
        [ngClass]="showIcon ? 'errorClass sdps-input sdps-input--small ' : 'sdps-input sdps-input--small '"
        [class.aligned-render-input]="params?.mode === 'render'" />
</ng-template>
<ng-template [ngIf]="!isNotManualFlow">
    <p class="textCell aligned-render-text">{{params.value}}</p>
</ng-template>
<div *ngIf="showIcon" class="tooltip-section">
    <span class="errorText" id="errorText">{{currentValue}}</span>
    <span 
        matTooltip="{{toolTipError}}" 
        matTooltipPosition="after"
        matTooltipClass="tooltip-content"
        class="sac-tooltip-icon">
    </span>
</div>